/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'
import missing from 'images/logo/white-on-black-wide.png'
import s from './AgentBadge.module.css'

export function AgentBadge({ createdBy, onRequestTour }) {
  const fullName = `${createdBy.first_name} ${createdBy.last_name}`

  return (
    <div className={s.root}>
      <div className={s.imageWrapper}>
        <img src={createdBy.photo_url ? createdBy.photo_url : missing} alt={fullName} className={s.image} />
      </div>

      <div className={s.agentInfo}>
        <div className={s.name}>{fullName}</div>
        {createdBy.licensed_as && <div className={s.licensedAs}>{createdBy.licensed_as}</div>}
        {createdBy.license_number && <div className={s.licenseNumber}>{createdBy.license_number}</div>}
      </div>

      <div className={s.contacts}>
        {createdBy.email && (
          <div className={s.email}>
            Email:{' '}
            <a href={`mailto:${createdBy.email}`} className={s.emailValue}>
              {createdBy.email}
            </a>
          </div>
        )}
        {createdBy.phone && (
          <div className={s.phone}>
            Tel.:{' '}
            <a href={`tel:${createdBy.phone}`} className={s.phoneValue}>
              {createdBy.phone}
            </a>
          </div>
        )}
      </div>

      <button type="button" className={s.requestTour} onClick={onRequestTour}>
        Request Tour
      </button>
    </div>
  )
}
